module.exports = __webpack_public_path__ + "static/media/Roboto-Italic.b391d0e9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roboto-Italic.ttf
// module id = 548
// module chunks = 0